import { ProductGoToActionBlock } from "../products";
import { StartGenerateAccountPlanBtn } from "../ui/buttons/StartGenerateAccountPlanBtn";
import { CampaignDetailsResponse } from "../../types/apiTypes";

export const StartGenerateAccountPlan = ({
  account_id,
  account,
  campaign_id,
}: {
  account_id: string;
  campaign_id: string;
  account: CampaignDetailsResponse;
}) => {
  return (
    <ProductGoToActionBlock
      title={`Get a Tailored Account Overview for ${account.output.company.name}`}
      texts={[
        "Discover company profile, growth strategy, relevant industry insights, key stakeholders analysis," +
          " and detailed engagement plan with conversation guidelines to boost your sales.",
      ]}
      btn={
        <StartGenerateAccountPlanBtn
          account_id={account_id}
          campaign_id={campaign_id}
          account={account}
        />
      }
    />
  );
};
